import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BoltOffFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M22.0452 3.03613L14.2825 10.7988H14.2991L10.6985 14.3984L10.7024 14.3779L2.96997 22.1113L1.69751 20.8389L9.39673 13.1396H4.46997L13.6897 2.65918H14.9104L13.4172 9.11816L20.7727 1.76367L22.0452 3.03613ZM10.3303 21.2793H9.10962L9.93286 17.71L16.845 10.7988H19.5295L10.3303 21.2793Z" />
    </SvgIcon>
  );
});
